import { InjectionToken } from '@angular/core';

export const TASK_SERVICE = new InjectionToken('TASK_SERVICE');
